import api from '@/services/api';
import Vue from 'vue';
import i18n from '@/i18n';

export default function reset({to, from, next}) {
    /**
     * Check if user has valid reset token
     */

    const params = new URLSearchParams();
    params.append('token', to.params.token);

    api.post('/api/check-reset', params)
        .then(() => {
            return next();
        }).catch((error) => {
            Vue.prototype.$toast?.error(i18n.t('messages.invalidToken'));
            return next({
                path: '/',
            });
            
        });
}